module.exports = __webpack_public_path__ + "img/default-icon.465627e.svg";